import { render, staticRenderFns } from "./updatePermissaoAcesso.vue?vue&type=template&id=b5656e8c&scoped=true&"
import script from "./updatePermissaoAcesso.vue?vue&type=script&lang=js&"
export * from "./updatePermissaoAcesso.vue?vue&type=script&lang=js&"
import style0 from "./updatePermissaoAcesso.vue?vue&type=style&index=0&id=b5656e8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5656e8c",
  null
  
)

export default component.exports